import { useEffect, useState } from 'react';
import { chargerPhotoDeBoite } from '../image';

/**
 * La photo d'un message de la Boite. Un <img src> direct n'enverrait pas le jeton :
 * l'image se charge par fetch authentifie puis s'affiche depuis un blob local, libere
 * au demontage. En cas d'echec, pas d'image et pas d'erreur : le texte suffit.
 */
export function PhotoDeBoite({ elementId }: { elementId: string }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let vivant = true;
    let urlLocale: string | null = null;
    chargerPhotoDeBoite(elementId)
      .then((chargee) => {
        urlLocale = chargee;
        if (vivant) setUrl(chargee);
        else URL.revokeObjectURL(chargee);
      })
      .catch(() => {
        // Photo indisponible : la carte vit tres bien sans.
      });
    return () => {
      vivant = false;
      if (urlLocale !== null) URL.revokeObjectURL(urlLocale);
    };
  }, [elementId]);

  if (url === null) return null;
  return (
    <img
      src={url}
      alt="Photo du message"
      style={{ maxWidth: '100%', maxHeight: 180, borderRadius: 10, alignSelf: 'flex-start' }}
    />
  );
}
